var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.941,
    height: 19.941,
    viewBox: "0 0 19.941 19.941",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#50c150;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-5289.029-1382.058a9.983,9.983,0,0,1-9.971-9.971,9.982,9.982,0,0,1,9.971-9.97,9.981,9.981,0,0,1,9.97,9.97A9.982,9.982,0,0,1-5289.029-1382.058ZM-5291-1396.2a1,1,0,0,0-1,1v6.391a1,1,0,0,0,1,1,1,1,0,0,0,.528-.153l5.113-3.2a1,1,0,0,0,.47-.849,1,1,0,0,0-.47-.848l-5.113-3.2a.994.994,0,0,0-.527-.154Z",
    transform: "translate(5299 1402)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.c1470f369e1f72daa20503e8e941b7f5.svg";
export { ForwardRef as ReactComponent };